/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Col, Row, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toHeaderCase } from 'js-convert-case';
import { Comments } from '../../../../pages/ApplicationDetail/components/comments';

export interface IStatusCompProps {
  statusComp: {
    statusType?: 'success' | 'danger' | 'warning';
    title?: string;
    description?: string;
  };
  iscomment?: any;
  showcomment?: any;
  closecomment?(): void;
  setShowComment: any;
  status?: any;
}
export const StatusComp = (props: IStatusCompProps) => {
  const { statusType, description, title } = props?.statusComp;
  const { iscomment, showcomment, closecomment, setShowComment, status } =
    props;
  const _renderDescription = () => {
    if (iscomment) {
      return (
        // <p className="fs-6 text-dark mb-0 w-100 align-justify">
        <div style={{ color: 'grey' }}>
          {title?.length > 18 ? title.substring(0, 18) + '...' : title}
          {/* // </p> */}
        </div>
      );
    }
    return null;
  };

  const _renderTitleIf = () => {
    if (status) {
      return <>{status}</>;
    }
  };
  console.log('statuscompinside', showcomment);
  return (
    <>
      <div className="d-flex">
        <div xs="auto" className="pl-3">
          <Alert variant={statusType} className="p-2 w-100">
            {_renderTitleIf()}
          </Alert>
        </div>
        <div className="ps-2 pt-2">
          <p style={{ fontWeight: 'bolder' }}>{_renderDescription()}</p>
        </div>
        <div>
          {iscomment && title?.length > 15 && (
            <div xs="auto" className="py-2 pl-2">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip className="m-0">{'Click to view comments'}</Tooltip>
                }
              >
                <img
                  src="https://i.ibb.co/DMf02rL/info.png"
                  onClick={() => setShowComment(true)}
                  height={15}
                  width={15}
                />
              </OverlayTrigger>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

StatusComp.defaultProps = {
  statusType: 'success',
  title: 'Status Title',
  description: 'Status Description',
};
